import React from 'react'

export const Heading = ({ title }) => {
  return (
    <div>
      <h2 className='heading' data-aos="zoom-in-down">{title}</h2>
    </div>
  )
}
